<template>
  <div class="online-content">
    <div class="online-TaskCenter">
      <div class="TaskCenter-title bg-base1">
        <p class="title" v-if="taskData.target.targetTitle">
          {{ taskData.target.targetTitle }}
        </p>
        <p class="title" v-else></p>
        <div class="history">
          <span class="name">
            {{
              $store.state.globalTxt.taskmenu2
                ? $store.state.globalTxt.taskmenu2
                : $t("TaskCenter.historyTask")
            }}
          </span>
          <div class="select-box" @click.stop="changeHistoryTask">
            <span class="hold">{{ selectobj.value }}</span>
            <span class="arrow icon-shangyiye color-aaa" ref="arrow"></span>
          </div>
          <div class="select-list" v-if="selectobj.visible">
            <template v-if="historyList.length > 0">
              <div
                class="list cur"
                :class="[{ colorOpcity: index == selectobj.index }]"
                @click="historyChange(item, index, item.hour_id)"
                v-for="(item, index) of historyList"
                :key="index"
              >
                <!-- <i
                  class="icon-renwuzhongxin"
                  style="color:#fff"
                  :class="{ 'color-base': index == selectobj.index }"
                ></i>-->
                <span>
                  <i
                    class="icon-renwuzhongxin"
                    v-if="index == selectobj.index"
                    :class="{ 'color-base': index == selectobj.index }"
                  ></i>
                  {{ item.hour_name }}
                </span>
                <em v-if="item.undonenums != 0">{{ item.undonenums }}</em>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="TaskCenter-box">
        <div class="TaskCenter-left">
          <ul>
            <li
              :class="taskobj.index == index ? 'beforeState' : ''"
              v-for="(item, index) of taskData.taskList"
              :key="index"
              @click="changeTask(index)"
            >
              <span>{{ item.name }}</span>
              <em v-if="item.num > 0">{{ item.num }}</em>
            </li>
          </ul>
        </div>
        <div class="TaskCenter-right">
          <div class="studyTarget" v-if="taskobj.visible">
            <h3>
              {{
                $store.state.globalTxt.taskmenu1
                  ? $store.state.globalTxt.taskmenu1
                  : $t("TaskCenter.studyTask")
              }}
            </h3>
            <div class="target">
              <div class="list">
                <!-- <p class="title">{{ taskData.target.targetTitle }}:</p> -->
                <ul>
                  <li>
                    <!-- <em class="bg-base1"></em> -->
                    <template v-if="taskData.target.targetContent">
                      <span
                        style="cursor: pointer;"
                        v-html="
                          taskData.target.targetContent.replace(
                            /(\r\n)|(\r)|(\n)/g,
                            '<br>'
                          )
                        "
                        >{{ taskData.target.targetContent }}</span
                      >
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="task-list" style="height: 100%;" v-else>
            <div class="brief-box">
              <div class="brief cursor" @click="goBrief">
                <em></em>{{ $t("TaskCenter.goback") }}
              </div>
            </div>
            <template
              v-if="taskData.taskList[this.taskobj.index].list.undonenums != 0"
            >
              <template
                v-if="
                  taskData.taskList[this.taskobj.index].name ==
                    $store.state.globalTxt.taskfence6
                "
              >
                <div style="height: calc(100% - 40px)">
                  <ScrollBox>
                    <template
                      v-if="taskData.taskList[this.taskobj.index].list.img"
                    >
                      <div
                        class="item"
                        v-for="(item, index) in taskData.taskList[
                          this.taskobj.index
                        ].list.img"
                        :key="index"
                      >
                        <p class="one">
                          <span class="word">{{ item.item_title }}</span>
                        </p>
                        <p
                          class="goFinish"
                          :class="{
                            'color-font': item.taskitem_status == 0,
                          }"
                          @click="linkToReview(item.item_tasktype, item)"
                        >
                          <template
                            v-if="item.taskitem_status == 0"
                            style="cursor: pointer;"
                          >
                            <template v-if="taskobj.index == 0">{{
                              $store.state.globalTxt.taskstate2
                                ? $store.state.globalTxt.taskstate2
                                : $t("TaskCenter.goFinessed")
                            }}</template>
                            <template v-else>{{
                              $t("TaskCenter.noFinessed")
                            }}</template>
                          </template>
                          <template
                            v-else-if="item.taskitem_status == 1"
                            style="cursor: pointer;"
                          >
                            {{
                              $store.state.globalTxt.taskstate1
                                ? $store.state.globalTxt.taskstate1
                                : $t("TaskCenter.Finessed")
                            }}
                          </template>
                        </p>
                      </div>
                    </template>
                    <template
                      v-if="taskData.taskList[this.taskobj.index].list.content"
                    >
                      <div
                        class="item"
                        v-for="(item, index) in taskData.taskList[
                          this.taskobj.index
                        ].list.content"
                        :key="`${index}-${index}`"
                      >
                        <p class="one">
                          <span class="word">{{ item.item_title }}</span>
                        </p>
                        <p
                          class="goFinish"
                          :class="{
                            'color-font': item.taskitem_status == 0,
                          }"
                          @click="linkToReview(item.item_tasktype, item)"
                        >
                          <template
                            v-if="item.taskitem_status == 0"
                            style="cursor: pointer;"
                          >
                            <template v-if="taskobj.index == 0">{{
                              $store.state.globalTxt.taskstate2
                                ? $store.state.globalTxt.taskstate2
                                : $t("TaskCenter.goFinessed")
                            }}</template>
                            <template v-else>{{
                              $t("TaskCenter.noFinessed")
                            }}</template>
                          </template>
                          <template
                            v-else-if="item.taskitem_status == 1"
                            style="cursor: pointer;"
                          >
                            {{
                              $store.state.globalTxt.taskstate1
                                ? $store.state.globalTxt.taskstate1
                                : $t("TaskCenter.Finessed")
                            }}
                          </template>
                        </p>
                      </div>
                    </template>
                    <template
                      v-if="taskData.taskList[this.taskobj.index].list.video"
                    >
                      <div
                        class="item"
                        v-for="(item, index) in taskData.taskList[
                          this.taskobj.index
                        ].list.video"
                        :key="`${index}-${new Date()}`"
                      >
                        <p class="one">
                          <span class="word">{{ item.item_title }}</span>
                        </p>
                        <p
                          class="goFinish"
                          :class="{
                            'color-font': item.taskitem_status == 0,
                          }"
                          @click="linkToReview(item.item_tasktype, item)"
                        >
                          <template
                            v-if="item.taskitem_status == 0"
                            style="cursor: pointer;"
                          >
                            <template v-if="taskobj.index == 0">{{
                              $store.state.globalTxt.taskstate2
                                ? $store.state.globalTxt.taskstate2
                                : $t("TaskCenter.goFinessed")
                            }}</template>
                            <template v-else>{{
                              $t("TaskCenter.noFinessed")
                            }}</template>
                          </template>
                          <template
                            v-else-if="item.taskitem_status == 1"
                            style="cursor: pointer;"
                          >
                            {{
                              $store.state.globalTxt.taskstate1
                                ? $store.state.globalTxt.taskstate1
                                : $t("TaskCenter.Finessed")
                            }}
                          </template>
                        </p>
                      </div>
                    </template>
                  </ScrollBox>
                </div>
              </template>
              <template v-else>
                <div style="height: calc(100% - 40px)">
                  <ScrollBox>
                    <div
                      class="item"
                      v-for="(item, index) in taskData.taskList[
                        this.taskobj.index
                      ].list"
                      :key="index"
                    >
                      <p class="one">
                        <span class="word">{{ item.item_title }}</span>
                      </p>
                      <p
                        class="goFinish"
                        :class="{
                          'color-font': item.taskitem_status == 0,
                        }"
                        @click="linkToReview(item.item_tasktype, item)"
                      >
                        <template
                          v-if="item.taskitem_status == 0"
                          style="cursor: pointer;"
                        >
                          <template v-if="taskobj.index == 0">{{
                            $store.state.globalTxt.taskstate2
                              ? $store.state.globalTxt.taskstate2
                              : $t("TaskCenter.goFinessed")
                          }}</template>
                          <template v-else>{{
                            $t("TaskCenter.noFinessed")
                          }}</template>
                        </template>
                        <template
                          v-else-if="item.taskitem_status == 1"
                          style="cursor: pointer;"
                        >
                          {{
                            $store.state.globalTxt.taskstate1
                              ? $store.state.globalTxt.taskstate1
                              : $t("TaskCenter.Finessed")
                          }}
                        </template>
                      </p>
                    </div>
                  </ScrollBox>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <pop-tips
      @handConfirm="handConfirm"
      @handleCloseTip="handleCloseTip"
      :dialogVisable="dialogVisable"
      :popTipsCont="popTipsCont"
    ></pop-tips>
  </div>
</template>

<script>
import TaskHttp from "./task";
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import ScrollBox from "@/components/ScrollBox";
import PopTips from "@/components/popTips";
export default {
  name: "TaskCenter",
  components: { ScrollBox, PopTips },
  data() {
    return {
      timer: null,
      curHistiryId: '',

      dialogVisable: false,
      popTipsCont: {
        title: this.$t("Common.tips"),
        context: "",
        btns: [
          {
            text: this.$t("Common.confirm"),
            event: "handConfirm",
          },
        ],
      },

      isSelected: false,
      taskobj: {
        index: -1,
        visible: true,
      },

      taskList: [],
      // 任务 详情
      taskData: {
        // 学习目标
        target: {
          targetTitle: "",
          targetContent: "",
        },
        taskList: [
          {
            // this.$t("TaskCenter.task1")
            name: this.$store.state.globalTxt.taskfence1,
            num: 0,
            list: [],
          },
          {
            name: this.$store.state.globalTxt.taskfence2,
            num: 0,
            list: [],
          },

          {
            name: this.$store.state.globalTxt.taskfence3,
            num: 0,
            list: [],
          },
          {
            name: this.$store.state.globalTxt.taskfence4,
            num: 0,
            list: [],
          },
          {
            name: this.$store.state.globalTxt.taskfence5,
            num: 0,
            list: [],
          },
          {
            name: this.$store.state.globalTxt.taskfence6,
            num: 0,
            list: [],
          },
        ],
      },

      //历史任务
      selectobj: {
        visible: false,
        value: this.$t("TaskCenter.choose"),
        index: -1,
      },
      historyList: [
        {
          index: "1",
          value: "WKT-UNIT1Lesson4WKT-UNIT1Lesson4",
          num: "32",
        },
        {
          index: "1",
          value: "WKT-456",
          num: "32",
        },
        {
          index: "1",
          value: "WKT-4444",
          num: "32",
        },
      ],
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        textbook_id: "", //教材ID
        textbook_cnname: "", //教材名称
        unit_id: "", //单元ID
        unitgroup_id: "", //组合单元ID
        ability_id: "", //能力ID
        isGroup: true, //是单元练习还是组合单元练习
        examine_branch: "", //检测编号
        examine_name: "", //检测名称
      },
    };
  },
  created() {
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.$store.dispatch("setLoadingStatus", true);
    this.student_id = this.$store.state.currentChild.student_id;
    this.getSudentTask();
    this.getSudentHistoryTask()
    // .then(() => {
    //   this.initData()
    // })
  },

  destroyed() {
    console.log('destroyed')
    console.log(this.timer, 'this.timer')
    this.curHistiryId = '' 
    if (this.timer) {
      window.clearInterval(this.timer)
    }
  },

  mounted() {
    let arrObj;
    this.$nextTick(() => {
      arrObj = this.$refs.arrow;
    });
    document.addEventListener(
      "click",
      () => {
        if (arrObj) {
          arrObj.style.transform = "translateY(-50%) rotate(180deg)";
          arrObj.style.transition = " 0.4s ease";
          this.selectobj.visible = false;
        }
        // this.$nextTick(() => {
        //   // const arrObj = this.$refs.arrow;
        //   arrObj.style.transform = "translateY(-50%) rotate(180deg)";
        //   arrObj.style.transition = " 0.4s ease";
        //   this.selectobj.visible = false;
        // })
      },
      false
    );
  },
  methods: {
    initData () {
      if (this.timer) {
        window.clearInterval(this.timer)
      }
      if (this.curHistiryId) {
        this.timer = window.setInterval(() => {
          this.getHistoryTask(this.curHistiryId);
        }, 2000)
      }
    },
    handConfirm() {
      this.dialogVisable = false;
    },
    handleCloseTip() {
      this.dialogVisable = false;
    },

    handleSelectElse() {
      let arrObj;
      this.selectobj.visible = false;
      if (this.selectobj.visible == false) {
        this.$nextTick(() => {
          arrObj = this.$refs.arrow;
          if (arrObj) {
            arrObj.style.transform = "translateY(-50%) rotate(180deg)";
            arrObj.style.transition = " 0.4s ease";
          }
        });
      }
    },
    getMapsStepsMedias(steps_id) {
      return new Promise((resove) => {
        TaskHttp.getMapsStepsMedias({
          member_id: this.$store.state.member_id,
          token: this.$store.state.token,
          student_id: this.student_id,
          steps_id,
        }).then((res) => {
          const { error, result } = res.data;
          if (error == 0) {
            resove({
              status: "ok",
              data: result.list,
            });
          }
        });
      });
    },
    linkToReview(type, item) {
      console.log(type, item);
      if (type == 1) {
        // 复习任务
        console.log("复习任务", item);
        if (item.steps_category == 6) {
          this.$store.dispatch("setLoadingStatus", true);
          this.getMapsStepsMedias(item.steps_id).then((res) => {
            if (res.status == "ok") {
              window.location.href = `${res.data.steps_outurl}&taskitem_id=${item.taskitem_id}&from=taskcenter`;
              this.$store.dispatch("setLoadingStatus", false);
            }
          });
        } else {
          if (item.games_id != 0) {
            if (item.games_url) {
              window.open(
                `${item.games_url}?member_id=${this.$store.state.member_id}&token=${this.$store.state.token}&student_id=${this.student_id}&steps_id=${item.steps_id}&taskitem_id=${item.taskitem_id}&from=taskcenter`,
                "_self"
              );
            } else {
              this.popTipsCont.context = this.$t("TaskCenter.load1");
              this.dialogVisable = true;
            }
          } else {
            if (item.taskitem_status == 0) {
              this.$router.push({
                path: `/Review/ReviewQuestions?id=${item.steps_id}&taskitem_id=${item.taskitem_id}&from=taskcenter`,
              });
            }
          }
        }
      } else if (type == 2) {
        // 检测任务
        console.log(item);
        if (item.taskitem_status == 0) {
          this.taskitem_id = item.taskitem_id;
          this.getTestpaperQuestion(item.testpaper_id);
        }
      } else if (type == 3) {
        // 线下任务
        this.popTipsCont.context = this.$t("TaskCenter.load2");
        this.dialogVisable = true;
      } else if (type == 6 || type == 7) {
        this.popTipsCont.context = this.$t("TaskCenter.load3");
        this.dialogVisable = true;
      } else if (type == 5) {
        // 亲子任务
        // this.popTipsCont.context = this.$t('TaskCenter.load2')
        // this.dialogVisable = true;
        window.open(`${item.item_resourceurl}`, "_self");
        //  window.open(`${item.item_resourceurl}?member_id=${this.$store.state.member_id}&token=${this.$store.state.token}&student_id=${this.student_id}&taskitem_id=${item.taskitem_id}&from=taskcenter`, '_self');
      } else if (type == 0) {
        // 课时视频任务
        if (item.taskitem_status == 0) {
          if (item.media_isouturl == 1) {
            window.open(item.media_html_url, "_blank");
          } else {
            this.$router.push({
              path: `/Classroom/ClassVideo?id=${item.media_id}&from=quket&taskitem_id=${item.taskitem_id}&item_id=${item.item_id}`,
            });
          }
        }
      }
    },
    //获取真题试卷检测编号 - 检测任务 跳转
    getTestpaperQuestion(testpaper_id) {
      evaluationStore
        .getTestpaperQuestion({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          testpaper_id: testpaper_id, //真题卷ID
        })
        .then((res) => {
          const { error, errortip, result } = res.data;
          if (error == 0) {
            const { examine_branch, examine_name } = result.list;
            console.log(examine_branch, examine_name);
            this.$router.push({
              path: "/subject",
              query: {
                examine_branch: examine_branch,
                examine_name: escape(examine_name),
                taskitem_id: this.taskitem_id,
                from: "task", //标识是从 作业任务的检测任务 过来的
              },
            });
          } else {
            this.popTipsCont.context = errortip;
            this.dialogVisable = true;
          }
        });
    },
    // 历史任务列表
    getSudentHistoryTask() {
      return new Promise(resolve => {
        TaskHttp.getSudentHistoryTask({
          member_id: this.$store.state.member_id,
          token: this.$store.state.token,
          student_id: this.student_id,
        }).then((res) => {
          const { error, result } = res.data;
          if (error == 0) {
            this.historyList = result.list;
            this.curHistiryId = result.list[0]['hour_id']
          } else {
            this.historyList = [];
            this.curHistiryId = ''
          }
          resolve()
          this.$store.dispatch("setLoadingStatus", false);
        });
      })
    },

    // 解析任务列表数据
    analysis(item) {
      
      const { examine, family, offline, read, review, recording } = item;
      // examine 检测任务, family 亲子任务, offline 线下任务, read 阅读任务, review 复习任务 , recording 录音任务

      this.taskData.taskList.forEach((e, i) => {
        if (this.$store.state.currentChild.class_genre != 'school') {
          if (e.name == this.$store.state.globalTxt.taskfence3) {
            this.taskData.taskList.splice(i, 1)
          }
        }
        switch (e.name) {
          case this.$store.state.globalTxt.taskfence1:
            e.num = review.undonenums;
            e.list = review.list;
            break;
          case this.$store.state.globalTxt.taskfence2:
            e.num = examine.undonenums;
            e.list = examine.list;
            break;
          case this.$store.state.globalTxt.taskfence3:
            e.num = offline.undonenums;
            e.list = offline.list;
            break;
          case this.$store.state.globalTxt.taskfence4:
            e.num = read.undonenums;
            e.list = read.list;
            break;
          case this.$store.state.globalTxt.taskfence5:
            e.num = family.undonenums;
            e.list = family.list;
            break;
          case this.$store.state.globalTxt.taskfence6:
            e.num = recording.undonenums;
            e.list = recording.list;
            e.list.img = recording.list.img ? recording.list.img : "";
            e.list.content = recording.list.content
              ? recording.list.content
              : "";
            e.list.video = recording.list.video ? recording.list.video : "";
            break;
          default:
            break;
        }
      });
    },

    // 任务详情
    getSudentTask() {
      TaskHttp.getSudentTask({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        timestamp: new Date().getTime(),
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          const { hour_target, hour_id, item } = result.list;
          const classcode_name = result.list.classcode_name
            ? result.list.classcode_name
            : "";
          const hour_name = result.list.hour_name ? result.list.hour_name : "";
          if (classcode_name == "" && hour_name == "") {
            this.taskData.target.targetTitle = `${classcode_name}${hour_name}`;
          } else {
            this.taskData.target.targetTitle = `${classcode_name} - ${hour_name}`;
          }
          this.taskData.target.targetContent = hour_target;

          if (item) {
            this.analysis(item);
            console.log(111);
          }
        }
      });
    },

    // 历史任务详情
    getHistoryTask(id) {
      TaskHttp.getHistoryTask({
        member_id: this.$store.state.member_id,
        token: this.$store.state.token,
        student_id: this.student_id,
        hour_id: id,
      }).then((res) => {
        const { error, result } = res.data;
        if (error == 0) {
          const { item } = result.list;
          const classcode_name = result.list.classcode_name
            ? result.list.classcode_name
            : "";
          const hour_name = result.list.hour_name ? result.list.hour_name : "";
          if (classcode_name == "" && hour_name == "") {
            this.taskData.target.targetTitle = `${classcode_name}${hour_name}`;
          } else {
            this.taskData.target.targetTitle = `${classcode_name} - ${hour_name}`;
          }
          this.taskData.target.targetContent = result.list.hour_target;
          this.analysis(item);
        }
      });
    },
    //切换任务
    changeTask(index) {
      console.log(index);
      this.taskobj.index = index;
      this.taskobj.visible = false;
    },
    goBrief() {
      this.taskobj.index = -1;
      this.taskobj.visible = true;
    },
    //下拉框选择
    changeHistoryTask() {
      const arrObj = this.$refs.arrow;
      if (!this.isSelected) {
        arrObj.style.transform = "translateY(-50%) rotate(0deg)";
        arrObj.style.transition = " 0.4s ease";
      } else {
        arrObj.style.transform = "translateY(-50%) rotate(180deg)";
        arrObj.style.transition = " 0.4s ease";
      }
      this.selectobj.visible = !this.selectobj.visible;
      this.isSelected = !this.isSelected;
    },
    //下拉框选择 - option
    historyChange(item, index, id) {
      console.log(item, index);
      const arrObj = this.$refs.arrow;
      if (!this.isSelected) {
        arrObj.style.transform = "translateY(-50%) rotate(0deg)";
        arrObj.style.transition = " 0.4s ease";
      } else {
        arrObj.style.transform = "translateY(-50%) rotate(180deg)";
        arrObj.style.transition = " 0.4s ease";
      }
      this.isSelected = !this.isSelected;

      this.selectobj.index = index;
      this.selectobj.value = item.hour_name;
      this.selectobj.visible = false;
      this.curHistiryId = id
      this.getHistoryTask(id);
    },
  },
};
</script>

<style lang="less">
@import url("./TaskCenter");
.history {
  z-index: 29 !important;
}
.goFinish {
  cursor: pointer;
}
.list.cur {
  line-height: 30px;
}
.select-list {
  padding-top: 10px !important;
  padding-bottom: 0 !important;
}
</style>
